import { IPreloadedState } from 'shared/types/redux';

export const selectMarketTrendsStatus = (state: IPreloadedState) => state.marketTrends.marketTrendsStatus;
